import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { BackupVault, RestoreAccount } from '@repo/api-gw-sdk';
import { VaultOwnBucketCopyableAllAccountsPolicy, VaultOwnBucketCopyablePolicy } from '@/components/vaults/vaultOwnBucketCopyablePolicy';
import { VaultOwnBucketEditKeyPolicyButton } from '@/components/vaults/vaultOwnBucketEditKeyPolicyButton';
export const OwnBucketSuggestedPolicyDialogBody = t0 => {
  const $ = _c(9);
  const {
    backupVault,
    restoreAccounts
  } = t0;
  let t1;
  if ($[0] !== backupVault.vaultAttributes.aws?.bucketName || $[1] !== restoreAccounts) {
    t1 = restoreAccounts ? <VaultOwnBucketCopyablePolicy bucketName={backupVault.vaultAttributes.aws?.bucketName || ""} restoreAccounts={restoreAccounts} /> : <VaultOwnBucketCopyableAllAccountsPolicy bucketName={backupVault.vaultAttributes.aws?.bucketName || ""} />;
    $[0] = backupVault.vaultAttributes.aws?.bucketName;
    $[1] = restoreAccounts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = backupVault.vaultAttributes.aws?.bucketName || "";
  let t3;
  if ($[3] !== backupVault.region || $[4] !== t2) {
    t3 = <VaultOwnBucketEditKeyPolicyButton region={backupVault.region} bucketName={t2} />;
    $[3] = backupVault.region;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <Stack paddingX="40px" gap="24px" alignItems="flex-end">{t1}{t3}</Stack>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};